// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5a1c3f74","75":"dc38552d","116":"abb4cdd5"}[chunkId] + ".chunk.js";
};